const doc = [({"en":({"js":({"admin":({"courses":({"edit":({"add_new_course":"Add new course", "edit_course":"Edit course: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;